import React, { Component } from 'react'
import DashboardButton from '../components/DashboardButton'
import { AddNewTalentIcon, AddProjectIcon, GlobeIcon, OldProjectsIcon, PersonIcon, TagIcon } from '../assets/icons'
import voiceStore from '../stores/voiceStore'
import SearchByTagsModal from '../modals/searchModals/SearchByTagsModal'
import SearchByNameModal from '../modals/searchModals/SearchByNameModal'
import SearchByLanguageModal from '../modals/searchModals/SearchByLanguageModal'
import projectStore from '../stores/projectStore'
import { Link } from 'react-router-dom'
import Button from "../components/Button";
import { SearchColoredIcon } from "../assets/icons";
import { useNavigate } from 'react-router-dom';


export default class DashboardOld extends Component {
    
    state = {
        isModalOpen: false,
        activeModal: null
       
    };
    openModal = (modal) => {
        this.setState({ isModalOpen: true, activeModal: modal });
    };

    closeModal = () => {
        this.setState({ isModalOpen: false, activeModal: null });
    };

    renderModal = () => {
        const { activeModal } = this.state;
        switch (activeModal) {
            case 'searchbytags':
                return <SearchByTagsModal closeModal={this.closeModal} />;
            case 'searchbyname':
                return <SearchByNameModal closeModal={this.closeModal} />;
            case 'searchbylanguage':
                return <SearchByLanguageModal closeModal={this.closeModal} />;
        
            default:
                return null;
        }
    };

    componentDidMount() {
        
        voiceStore.getDropdownData();
    }
   

    render() {

        return (
            <div className='flex flex-1 flex-col pb-20'>
                <div className='flex mt-10'>
                    <div>
                         
                       
                        <div className='flex flex-wrap justify-center items-center gap-x-12 gap-y-6 lg:gap-y-9 mx-11 2xl:mx-80'>
                            <DashboardButton onClick={() => {
                                this.openModal('searchbytags')
                            }} icon={TagIcon} title={"Search By Tags"}></DashboardButton>
                            <DashboardButton onClick={() => {
                                this.openModal('searchbyname')
                            }} icon={PersonIcon} title={"Search By Name"}></DashboardButton>
                            <DashboardButton onClick={() => {
                                this.openModal('searchbylanguage')
                            }} icon={GlobeIcon} title={"Search By Language"}></DashboardButton>
                           
                            <DashboardButton onClick={() => {
                                projectStore.setCreateNewProjectModalVisible(true);
                            }} icon={AddProjectIcon} title={"Create New Project"}></DashboardButton>
                            <Link className='w-full lg:w-80' to='/projects'>
                                <DashboardButton icon={OldProjectsIcon} title={"Projects"}></DashboardButton>
                            </Link>
                            <DashboardButton onClick={() => {
                                voiceStore.changeStepperVisible(true);
                            }} icon={AddNewTalentIcon} title={"Create New Talent"}></DashboardButton>
                              <DashboardButton onClick={() => {
                                projectStore.setAddTagsModalVisible(true);
                            }} icon={TagIcon} title={"Add New Tags"}></DashboardButton>
                        </div>
                    </div>

                </div>
                {this.state.isModalOpen && (
                    <div className="modal-overlay">
                        {this.renderModal()}
                    </div>
                )}
            </div>

        )
    }
}
